import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { PREMIUM_BOND_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import RecordsSection, { RecordsSubSectionProps } from './records-section'
import getValueTotal from './value-total'

const PremiumBonds = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => (
  <RecordsSection
    heading="2.4 Premium bonds"
    cardType="Premium bond"
    addLabel="Add premium bond"
    toggleName="premiumBondsSectionActive"
    sectionActive={sectionActive}
    saveProbateEstateField={saveProbateEstateField}
    collection={collection}
    totals={{ total: getValueTotal(collection.items) }}
    schema={PREMIUM_BOND_SCHEMA}
    renderFields={({ handleSave, pairedFieldSpan }) => (
      <>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="referenceNumber"
            label="Premium bond holder’s number"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="value"
            label="Value (£)"
            isCurrency
            handleSave={handleSave}
          />
        </Grid.Item>
      </>
    )}
  />
)

export default PremiumBonds
